import { useQuery } from '@tanstack/react-query';

import { fetchHome } from '@/api/me';

export function useHome() {
  return useQuery({
    queryKey: ['miniapp', 'home'],
    queryFn: fetchHome,
    staleTime: 30 * 1000,
  });
}
